import React from 'react';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';
function DocumentRow(props) {
    return (
        <section className="documentitemview">
            {/* docid */}
            <section className="documentitem grid id">
                    <EllipsesControl
                                content={props.data.documentId}
                                tooltip={props.data.documentId}
                                displayId={''}
                                noOfLines={1}
                                ellipsisClass=""
                            /> 
            </section>
            {/* doc version */}
            <section className="documentitem grid version">
                    <EllipsesControl
                                content={props.data.documentVersion}
                                tooltip={props.data.documentVersion}
                                displayId={''}
                                noOfLines={1}
                                ellipsisClass=""
                            />
            </section>
            {/* doc name */}
            <section className="documentitem grid description">
                     <EllipsesControl
                                content={props.data.documentName}
                                tooltip={props.data.documentName}
                                displayId={''}
                                noOfLines={1}
                                ellipsisClass=""
                            />
            </section>
            {/* doc fileSize */}
            <section className="documentitem grid filesize">
                    <EllipsesControl
                                content={props.data.fileSize}
                                tooltip={props.data.fileSize}
                                displayId={''}
                                noOfLines={1}
                                ellipsisClass=""
                            />
            </section>
            {/* doc contenturi */}
            <section className="documentitem grid uri">
                        <EllipsesControl
                                content={props.data.contentUri}
                                tooltip={props.data.contentUri}
                                displayId={''}
                                noOfLines={1}
                                ellipsisClass=""
                            />
            </section>
            {/* doc file exists */}
            <section className="documentitem grid fileexist">
                    <EllipsesControl
                                content= {'' + props.data.fileExists}
                                tooltip= {'' + props.data.fileExists}
                                displayId={''}
                                noOfLines={1}
                                ellipsisClass=""
                            />
            </section>
        </section>
    );
}

export default DocumentRow;
